import { useStore } from 'dashboard/composables/store';
import { generateStatisticsFileName } from 'dashboard/helper/downloadHelper';
import { buildSummaryReportParams } from 'dashboard/api/buildSummaryReportParams';

const DISPATCH_BY_TYPE = {
  agent: 'downloadAgentReports',
  team: 'downloadTeamReports',
  inbox: 'downloadInboxReports',
  label: 'downloadLabelReports',
};

export function useSummaryReportDownload(reportType, getFilters) {
  const store = useStore();

  const downloadReports = () => {
    const filters = getFilters();
    const dispatch = DISPATCH_BY_TYPE[reportType];
    if (!dispatch || !filters?.from || !filters?.to) return;

    const fileName = generateStatisticsFileName({
      type: reportType,
      from: filters.from,
      to: filters.to,
    });

    store.dispatch(dispatch, {
      fileName,
      from: filters.from,
      to: filters.to,
      ...buildSummaryReportParams({
        from: filters.from,
        to: filters.to,
        labelIds: filters.labelIds,
        excludeLabelIds: filters.excludeLabelIds,
        inboxIds: filters.inboxIds,
        teamIds: filters.teamIds,
        agentIds: filters.agentIds,
        channelTypes: filters.channelTypes,
        episodeResult: filters.episodeResult,
        receiptType: filters.receiptType,
        tagPresence: filters.tagPresence,
        resolutionMethod: filters.resolutionMethod,
        comparisonPeriods: filters.comparisonPeriods,
      }),
    });
  };

  return { downloadReports };
}
